/**
 * Converts WhatsApp text formatting to HTML
 * Supports:
 * - *text* -> <strong>text</strong> (bold)
 * - _text_ -> <em>text</em> (italic)
 * - ~text~ -> <del>text</del> (strikethrough)
 * - ```text``` -> <code>text</code> (monospace)
 */

export const parseWhatsAppFormatting = (text) => {
  if (!text) return '';
  
  // Escape HTML to prevent XSS
  let formatted = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
  
  // Process code blocks first (triple backticks)
  formatted = formatted.replace(/```([^`]+)```/g, '<code style="background-color: #f0f0f0; padding: 2px 4px; border-radius: 3px; font-family: monospace;">$1</code>');
  
  // Process inline code (single backticks)
  formatted = formatted.replace(/`([^`]+)`/g, '<code style="background-color: #f0f0f0; padding: 2px 4px; border-radius: 3px; font-family: monospace;">$1</code>');
  
  // Process bold (*text*)
  // Negative lookbehind and lookahead to avoid matching multiple asterisks
  formatted = formatted.replace(/(?<!\*)\*(?!\*)([^*]+)\*(?!\*)/g, '<strong>$1</strong>');
  
  // Process italic (_text_)
  formatted = formatted.replace(/(?<!_)_(?!_)([^_]+)_(?!_)/g, '<em>$1</em>');
  
  // Process strikethrough (~text~)
  formatted = formatted.replace(/(?<!~)~(?!~)([^~]+)~(?!~)/g, '<del>$1</del>');
  
  // Convert newlines to <br> tags
  formatted = formatted.replace(/\n/g, '<br />');
  
  // Convert URLs to clickable links
  formatted = formatted.replace(
    /(https?:\/\/[^\s<]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer" style="color: #0066cc; text-decoration: underline;">$1</a>'
  );
  
  return formatted;
};
